/* global $, breakdown_data, type */
import Table from 'bam-node-savant-table/table'

import { threeDigitFormat } from '../utils'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'breakdown'

$(document).ready(() => {
    let statsTable

    $('#ddlType').val(type)

    if (type) {
        $('#lblType').html($('#ddlType option:selected').text())
    }
    const columns = getColumns($('#ddlType').val())

    $('.form').change(() => {
        const newYear = $('#ddlYear').val()
        const newType = $('#ddlType').val()

        // Flash the correct year for a moment
        $('#lblYear').html(newYear)

        window.location = `/statcast_hit_probability?year=${newYear}&type=${newType}`
    })

    if (!statsTable && breakdown_data.length > 0) {
        // Launch Direction has no sub table
        if ($('#ddlType').val() === 'ld') {
            // eslint-disable-next-line no-new
            new Table({
                id: 'breakdown',
                headers: columns,
                defaultSort: 'value',
                data: breakdown_data,
            })
        } else {
            // eslint-disable-next-line no-new
            new Table({
                id: 'breakdown',
                headers: columns,
                subDataId: 'value',
                defaultSort: 'value',
                data: breakdown_data,
            })
        }
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $('#breakdown').on('click', '.default-table-row', function clickHandler() {
        if ($('#ddlType').val() !== 'ld') {
            const value = this.id.split('_')[1]
            if ($(`#breakdown-trSub_${value}`).is(':visible')) {
                $(`#breakdown-trSub_${value}`).hide()
            } else {
                $.ajax({
                    method: 'GET',
                    url: 'statcast_hit_probability',
                    data: {
                        value,
                        type: $('#ddlType').val(),
                        year: $('#ddlYear').val(),
                    },
                }).done((json) => {
                    $(`#breakdown-tdSub_${value}`).html(
                        `<div style="padding-left: 20px; overflow-x: auto;" id="data_${value}"></div>`
                    )
                    $(`#breakdown-trSub_${value}`).show()

                    // Assume only two options for now
                    const inputAbbrev =
                        $('#ddlType').val() === 'la' ? 'ev' : 'la'

                    const laColumns = getColumns(inputAbbrev)

                    let type = ''
                    // Do opposite of Type DDL
                    if ($('#ddlType').val() === 'ev') {
                        type = `Launch Angle (Deg) <br/> <span style="font-weight: normal; color: #848484; font-size: 0.8rem;">${value} MPH Exit Velocity</span>`
                    }
                    if ($('#ddlType').val() === 'la') {
                        type = `Exit Velocity (MPH) <br/> <span style="font-weight: normal; color: #848484; font-size: 0.8rem;">${value}° Launch Angle</span>`
                    }

                    laColumns[0].name = type

                    // eslint-disable-next-line no-new
                    new Table({
                        id: `data_${value}`,
                        headers: laColumns,
                        defaultSort: 'value',
                        data: json,
                    })
                })
            }
        }
    })
})

window.addEventListener('scroll', () => {
    if (!ticking && breakdown_data.length) {
        window.requestAnimationFrame(() => {
            checkHeaderPosition(tableDivId)
            ticking = false
        })

        ticking = true
    }
})

function checkHeaderPosition(divId) {
    const scrollPosY = window.scrollY
    const posTop = $(`#${divId}`).offset().top
    const height = $(`#${divId} table thead`).height()
    if (!isFixedHeaderShowing && posTop < scrollPosY) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
        $(`#${divId} > table > thead`).removeClass('fixed-header')
        isFixedHeaderShowing = false
    }
}

function addStaticHeader(divId) {
    const width = $(`#${divId}`).outerWidth()
    // $(".tr-component-row th").removeClass("column-sort");

    if (width && width > 767) {
        // console.log(width);
        let tableCell = 0

        // Set TH Width before applying fixed-header
        $('.default-table-row')
            .first()
            .children('td')
            .each(function eachHandler() {
                const thWidth = $(this).outerWidth()
                $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                    'width',
                    thWidth
                )
                tableCell += 1
            })

        $(`#${divId} > table > thead`).addClass('fixed-header')
        tableCell = 0

        // Set TD Width before applying fixed-header
        $('.tr-component-row')
            .children('th')
            .each(function eachHandler() {
                const thWidth = $(this).outerWidth()
                $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                    'width',
                    thWidth
                )
                tableCell += 1
            })
    }
}

$(document).on('click', 'th.th-component-header', () => {
    isFixedHeaderShowing = false
    checkHeaderPosition(tableDivId)
})

window.addEventListener('resize', () => {
    if (isFixedHeaderShowing) {
        addStaticHeader(tableDivId)
    }
})

function getColumns(typeAbbrev) {
    let type = 'Exit Velocity (MPH)'

    if (typeAbbrev === 'la') {
        type = 'Launch Angle (Deg)'
    }
    if (typeAbbrev === 'ld') {
        type = 'Launch Direction (Deg)'
    }

    return [
        {
            name: type,
            field: 'value',
            type: 'number',
            headerClass: 'th-component-header align-left',
            fieldClass: 'tr-data align-left',
        },
        {
            name: 'Hits',
            field: 'n_hits',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
            displayFn: (val) => val && Number(val).toLocaleString(),
        },
        {
            name: 'BBE',
            field: 'n_hip',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
            displayFn: (val) => val && Number(val).toLocaleString(),
        },
        {
            name: 'Average <br/>Distance (ft)',
            field: 'avg_distance',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
        },
        {
            name: 'AVG',
            field: 'hits_per_hip',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
            displayFn: (value) => threeDigitFormat(value),
        },
        {
            name: 'wOBA',
            field: 'woba',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
            displayFn: (value) => threeDigitFormat(value),
        },
        {
            name: '1B',
            field: 'n_hits_1b',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
            displayFn: (val) => val && Number(val).toLocaleString(),
        },
        {
            name: '2B',
            field: 'n_hits_2b',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
        },
        {
            name: '3B',
            field: 'n_hits_3b',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
        },
        {
            name: 'HR',
            field: 'n_hits_hr',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
        },
        {
            name: '1B %',
            field: 'hits_1b_per_hip',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
        },
        {
            name: '2B %',
            field: 'hits_2b_per_hip',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
        },
        {
            name: '3B %',
            field: 'hits_3b_per_hip',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
        },
        {
            name: 'HR %',
            field: 'hits_hr_per_hip',
            type: 'number',
            headerClass: 'th-component-header align-right',
            fieldClass: 'tr-data align-right',
        },
    ]
}
